import "./ie11Shim";
import React from "react";
import ReactDOM from "react-dom";
import App from "app/App";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";

import { createBrowserHistory } from "history";
import { BASENAME } from "./lib/routing";

import "@fortawesome/fontawesome-free/css/all.css";
import { createStore } from "app/StoreFactory";

const history = createBrowserHistory({ basename: BASENAME });
const store = createStore(history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// Change to all dummy change

// serviceWorker.register(); // uses google CDN forbidden by content policy

const swUrl = `${process.env.PUBLIC_URL}/static/service-worker-custom.js`;
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(swUrl)
    .then(function () {})
    .catch(function (err) {
      console.error("ServiceWorker registration failed: ", err);
    });
}
